document.addEventListener('turbolinks:load', function(event) {
  if (typeof gtag === 'function') {
    gtag('config', 'G-P50XWTTZPG', {
      'page_location': event.data.url,
      'anonymize_ip': true
    })
  }
})
